// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCrhctgThJBJv3zhtVhDlsE11xjVGaL6WY',
    authDomain: 'aslearn-6757e.firebaseapp.com',
    databaseURL: 'https://aslearn-6757e.firebaseio.com',
    projectId: 'aslearn-6757e',
    storageBucket: 'aslearn-6757e.appspot.com',
    messagingSenderId: '336109096323'
  }
};



// WEBPACK FOOTER //
// /Users/HirdayGupta/Documents/UCLA/SB18/aslearn/src/environments/environment.ts